// extracted by extract-css-chunks-webpack-plugin
module.exports = {"md-fab-bottom-right":"md-fab-bottom-right"};